"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FABModal = void 0;
const helper_1 = require("./helper");
class FABModal {
    /** Init */
    init() {
        this.FABModal();
        this.FABAutoDetectCaptcha();
        this.FABCloseLink();
    }
    FABModal() {
        let FABModal = this;
        jQuery('.fab-container .fab-links').each(function () {
            let type = helper_1.FABHelper.getAttribute(jQuery(this).data('id'), 'type');
            let nonAllowedTypes = ['anchor_link', 'link', 'latest_post_link', 'print', 'scrolltotop', 'featured_product', 'apply_coupon', 'quick_purchase'];
            if (nonAllowedTypes.indexOf(type) === -1) {
                jQuery(this).click(function () {
                    /** Uncheck FAB */
                    jQuery('#fab-checkbox').prop('checked', false);
                    jQuery('#fab-checkbox').prop('checked', false);
                    jQuery('#fab-checkbox').trigger('click');
                    jQuery('#fab-checkbox').click();
                    /** Grab Data */
                    let button = this;
                    let index = window.FAB_PLUGIN.to_display.findIndex((e) => e.ID === jQuery(button).data('id'));
                    let fab = window.FAB_PLUGIN.to_display[index];
                    let dialogs = window.FAB_PLUGIN.dialogs || {};
                    let targetModal = `#fab-modal-${fab.ID}`;
                    /** Theme */
                    let theme = [
                        `fab-modal-${fab.ID}`,
                        (fab.modal.theme.id !== undefined) ? `theme-${fab.modal.theme.id}` : `theme-blank`,
                        helper_1.FABHelper.getAttribute(jQuery(this).data('id'), 'size')['type'], // BoxSize
                    ];
                    /** Load Dialog */
                    let option = {
                        title: jQuery(targetModal).data('title'),
                        icon: jQuery(targetModal).data('icon'),
                        content: jQuery(targetModal).children(":first"),
                        draggable: (fab['modal']['navigation'].draggable) ? true : false,
                        escapeKey: (fab['modal']['navigation'].escapeKey) ? true : false,
                        backgroundDismiss: (fab['modal']['navigation'].backgroundDismiss) ? true : false,
                        closeIconClass: `fas fa-times text-base`,
                        theme: theme.join(','),
                        animation: 'fabcustomcloseanimation',
                        closeAnimation: 'fabcustomcloseanimation',
                        animationSpeed: '1000',
                        onOpenBefore: function () {
                            /** Animation */
                            let container = jQuery('.jconfirm-box-container');
                            container.hide();
                            setTimeout(function () {
                                container.show();
                                container.addClass('jconfirm-animation-fabmodalopen');
                            }, 1);
                            /** Styling - FAB Container */
                            let fabStyling = `fab-container `;
                            fabStyling += (this.draggable) ? 'fab-modal-draggable ' : 'fab-modal-notdraggable'; // Check Dragabble
                            jQuery('.jconfirm').addClass(fabStyling);
                        },
                        onOpen: function () {
                            /** Extra Navigation Button */
                            jQuery('.jconfirm-closeIcon').before(`<ul class="jconfirm-navigation"></ul>`);
                            jQuery('.jconfirm-closeIcon').prepend(`<div>&nbsp;</div>`);
                            /** Navigation Maximize */
                            if (fab['modal']['navigation'].buttons.maximize) {
                                FABModal.NavigationMaximize(button);
                            }
                            /** Navigation Hotkey */
                            FABModal.NavigationHotkey(helper_1.FABHelper.getAttribute(fab.ID, 'hotkey'));
                        },
                        onClose: function () {
                            /** Animation */
                            let container = jQuery('.jconfirm-box-container');
                            container.addClass('jconfirm-animation-fabmodalclose');
                            /** Put Back The Content */
                            let element = Object.assign({}, this.content);
                            this.setContent(this.content.html());
                            jQuery(targetModal).html(element);
                        },
                    };
                    dialogs[targetModal.replace('#', '')] = jQuery.dialog(option);
                    window.FAB_PLUGIN.dialogs = dialogs;
                });
            }
        });
    }
    /**
     * Auto Detect Captcha v3
     * */
    FABAutoDetectCaptcha() {
        let AutoDetect = window.FAB_PLUGIN.features.core_miscellaneous.captcha.children.detectlocation.value;
        if (AutoDetect) {
            if (jQuery('.wpcf7-form').length && window.innerWidth >= 640) {
                setTimeout(function () {
                    jQuery('.grecaptcha-badge').css('top', '250px');
                    jQuery('.grecaptcha-badge').css('display', 'block');
                    jQuery('.grecaptcha-badge').css('visibility', 'visible');
                }, 500);
            }
        }
    }
    /**
     * Close Modal Link
     * */
    FABCloseLink() {
        jQuery('.fabclosemodal').on('click', function () {
            FABModal.CloseDialog();
        });
    }
    /**
     * Enable only single dialog to be active
     * */
    static CloseDialog() {
        let dialogs = window.FAB_PLUGIN.dialogs || {};
        for (let i in dialogs) {
            dialogs[i].close();
        }
    }
    /**
     * Navigation Maximize Button
     * */
    NavigationMaximize(button) {
        jQuery('.jconfirm-navigation').append(`<li class="jconfirm-maximize cursor-pointer"><div>&nbsp;</div><i class="fas fa-compress-alt"></i></li>`);
        jQuery('.jconfirm-maximize').on('click', function () {
            let confirmBox = jQuery('.jconfirm-box');
            if (confirmBox.data('maximize') == 'true') {
                FABModal.CloseDialog();
                jQuery(button).trigger('click');
            }
            else {
                jQuery('.jconfirm').addClass('jconfirm-maximized');
                jQuery('.jconfirm-box-container').css('transform', 'translate(0,0)');
                jQuery('.jconfirm-box').data('maximize', 'true');
            }
        });
    }
    NavigationHotkey(hotkey) {
        if (hotkey) {
            hotkey = hotkey.replace('ctrl', '⌃');
            hotkey = hotkey.replace('alt', '⌥');
            hotkey = hotkey.replace('shift', '⇧');
            hotkey = hotkey.replace('+', ' ');
            hotkey = `<li class="inline-block absolute hidden md:block jconfirm-hotkey">${hotkey.toUpperCase()}</li>`;
            jQuery('.jconfirm-navigation').append(hotkey);
        }
    }
}
exports.FABModal = FABModal;
